import './App.css';
import Card from './card';
import Layout from './components/Layout';
import logo from './images/logo.png'
import { useEffect, useState } from 'react';
import NavBar from './NavBar';

function Appuntamenti() {
    const [activities, setActivities] = useState([])
    const [now, setNow] = useState(false)

    const activeOrInactive = (e) => {
        if (e === true) {
            return 'bg-black text-white p-5 rounded-xl font-bold'
        }
        else {
            return 'bg-[#1A1919] text-[#87858560] p-5 rounded-xl font-bold'
        }
    }
  
    const name = localStorage.getItem('name')
    return (
        <Layout>
            <div className='flex w-full h-full flex-col overflow-scroll'>

                <div className='flex flex-1'>

                    <div className='flex flex-1 flex-col items-start '>
                        <div className='flex flex-row justify-start items-start mb-4'>
                        <button onClick={() => setNow(false)} className={activeOrInactive(!now)}>Partite future</button>
                        <button onClick={() => setNow(true)} className={activeOrInactive(now)} style={{marginLeft: '12px'}}>Partite passate</button> 
                        </div>

                        <Card now={now} />



                    </div>

                </div>
            </div>

        </Layout>
    );
}

export default Appuntamenti;


